var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-country-code',{attrs:{"defaultCountry":_vm.defaultCountry,"onlyCountries":['nl', 'gb', 'de', 'fr', 'es', 'se'],"dropdownOptions":{disabledDialCode:true}},on:{"onSelect":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }